import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_ROUTE_APP } from 'src/app/models/const';

@Component({
    selector: 'app-maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    styleUrls: ['./maintenance-mode.component.scss'],
    standalone: false
})
export class MaintenanceModeComponent implements OnInit {

  public dateFrom: string;
  public dateUntil: string;
  public showDates: boolean = false;

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('maintenanceFrom')) {
      this.dateFrom = localStorage.getItem('maintenanceFrom');
      this.dateUntil = localStorage.getItem('maintenanceUntil');
      this.showDates = true;
    }
  }

  goHomePage() {
    this.router.navigateByUrl(DEFAULT_ROUTE_APP);
  }
}
